import type { Participant } from "livekit-client";

export function getParticipantDisplayName(participant: Participant): string {
	let displayName = participant.identity;

	if (participant.metadata) {
		try {
			const metadata = JSON.parse(participant.metadata);
			displayName = metadata.displayName || displayName;
		} catch {
			// Malformed metadata leaves the identity as the display name.
		}
	}

	return displayName;
}

type TrackWithParticipant = {
	publication?: {
		track?: unknown;
		isMuted?: boolean;
	};
	participant: {
		isCameraEnabled?: boolean;
		isMicrophoneEnabled?: boolean;
	};
};

export function sortTracksByActivity<T extends TrackWithParticipant>(
	tracks: T[]
): T[] {
	return [...tracks].sort((a, b) => {
		const aHasVideo = a.participant.isCameraEnabled;
		const bHasVideo = b.participant.isCameraEnabled;
		const aHasMic = a.participant.isMicrophoneEnabled;
		const bHasMic = b.participant.isMicrophoneEnabled;

		// Participants with video sort first.
		if (aHasVideo && !bHasVideo) return -1;
		if (!aHasVideo && bHasVideo) return 1;

		if (aHasMic && !bHasMic) return -1;
		if (!aHasMic && bHasMic) return 1;

		return 0;
	});
}
